import Chartist from "chartist";
import moment from "moment";

function addHover(chartEl, formatter) {
  chartEl.addEventListener("mouseover", e => {
    const value = e.target.getAttribute("ct:value");
    if (value) {
      const rect = e.target.getBoundingClientRect();
      const el = document.getElementById("chart-tooltip");
      if (el.style.display !== "block") {
        el.style.display = "block";
        el.style.left = `${rect.x}px`;
        el.style.top = `${rect.y - 25}px`;
        el.innerHTML = formatter(value);
      }
    }
  });

  chartEl.addEventListener("mouseout", e => {
    const value = e.target.getAttribute("ct:value");
    if (value) {
      const el = document.getElementById("chart-tooltip");
      el.style.display = "none";
      el.innerHTML = "";
    }
  });
}

export function renderBarChart(domId, data) {
  const el = document.getElementById(domId);
  addHover(el, v => `<strong>${v}%</strong>`);

  return new Chartist.Bar(el, data).on("draw", series => {
    if (series.type === "bar") {
      series.element.attr({
        style: "stroke-width: 30px"
      });
    }
  });
}

export function renderLineChart(domId, data, dateFormat) {
  const el = document.getElementById(domId);

  addHover(el, v => {
    const [timestamp, value] = v.split(",", 2);
    return `${moment(Number.parseInt(timestamp, 10)).format(
      "lll"
    )}: <strong>${value}ms</strong>`;
  });

  return new Chartist.Line(
    el,
    {
      series: [
        {
          data
        }
      ]
    },
    {
      axisX: {
        type: Chartist.FixedScaleAxis,
        divisor: 8,
        labelInterpolationFnc(value) {
          return moment(value).format(dateFormat);
        }
      }
    }
  );
}



// WEBPACK FOOTER //
// ./src/charts.js